import type { NextPage } from 'next'
import { FinishingTouches } from '@/client/modules/FinishingTouches'
import { FinishingTouchesProps } from '@/client/modules/FinishingTouches/types'
import { getCMSContent } from '@/client/utils'

const FinishingTouchesPage: NextPage<FinishingTouchesProps> = (data) => <FinishingTouches {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'FINISHING_TOUCHES')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default FinishingTouchesPage
